var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 90,
    fill: "none",
    viewBox: "0 0 119 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85.01,
    height: 56.4,
    x: 18.65,
    y: 16.11,
    fill: "#fff",
    stroke: "#5862F7",
    strokeWidth: 6.8,
    rx: 6.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5862F7",
    d: "M31.6 50.4c.1-.44.5-.75.97-.75h3.42c.46 0 .85.3.96.75l.7 2.85c.1.44.5.75.96.75h1.08c.65 0 1.12-.6.96-1.23L36.38 35.7a.99.99 0 0 0-.96-.75h-2.26c-.46 0-.86.3-.97.75l-4.27 17.08a.99.99 0 0 0 .96 1.23h1.09a1 1 0 0 0 .96-.76l.67-2.83Zm2.2-9.04c.13-.5.84-.5.97 0l1.09 4.54a.5.5 0 0 1-.48.61h-2.2a.5.5 0 0 1-.48-.6l1.1-4.55ZM47.93 54a5.65 5.65 0 0 0 5.69-5.63c0-1.17-.36-2.24-1.02-3.13-.39-.52-.35-1.3.05-1.81.7-.88.97-1.92.97-3.04a5.5 5.5 0 0 0-5.7-5.45h-4.2a.99.99 0 0 0-1 .99v17.08a1 1 0 0 0 1 1h4.2Zm-1.08-11.24a.99.99 0 0 1-1-1v-2.7a1 1 0 0 1 1-.99h1.08c1.6 0 2.56 1 2.56 2.34 0 1.34-.96 2.35-2.56 2.35h-1.08Zm0 8.11a.99.99 0 0 1-1-.99v-3.03a1 1 0 0 1 1-.99h1.08c1.6 0 2.56 1.17 2.56 2.5 0 1.34-.96 2.51-2.56 2.51h-1.08ZM64.7 35.93a.99.99 0 0 0-.99-.99h-.93c-.46 0-.84.32-1.03.73a2.85 2.85 0 0 1-2.12 1.6c-.5.11-.92.53-.92 1.05v.53a1 1 0 0 0 1 1h.87a1 1 0 0 1 1 .98v12.18c0 .55.43 1 .98 1h1.15a1 1 0 0 0 1-1V35.93Zm13.97 4.27a5.37 5.37 0 0 0-5.56-5.53 5.49 5.49 0 0 0-5.55 5.66c0 .48.39.87.87.87h1.41c.47 0 .85-.37.85-.84 0-1.6 1.09-2.56 2.42-2.56 1.34 0 2.43.95 2.43 2.42v.14c0 1.09-.77 2.02-1.67 2.78l-2.9 2.48c-2.43 2.04-3.41 4.22-3.41 6.67V53a1 1 0 0 0 .99 1h9a1 1 0 0 0 .98-1v-1.15a.99.99 0 0 0-.99-.99h-5.48c-.58 0-1.05-.52-.8-1.05a5.1 5.1 0 0 1 1.3-1.56l2.38-2.02c2.1-1.77 3.73-3.32 3.73-5.77v-.27Zm4.05.73a.7.7 0 0 0 .71-.7 2.43 2.43 0 0 1 4.85 0v.13a2.43 2.43 0 0 1-2.43 2.42h-.56a.99.99 0 0 0-.99 1v1.12a1 1 0 0 0 1 .99h.55a2.43 2.43 0 0 1 2.43 2.42v.41a2.43 2.43 0 0 1-4.85 0 .57.57 0 0 0-.57-.57h-1.99a.57.57 0 0 0-.57.57 5.56 5.56 0 0 0 11.11 0v-.4c0-1.18-.3-2.26-.93-3.14a1.55 1.55 0 0 1 .02-1.78c.64-.88.91-1.95.91-3.07v-.13a5.54 5.54 0 0 0-5.56-5.53 5.54 5.54 0 0 0-5.55 5.53c0 .4.33.73.73.73h1.7Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlate);
export default __webpack_public_path__ + "static/media/icon-plate.14695f54.svg";
export { ForwardRef as ReactComponent };